import React from "react";

export default function ExampleCard({ title, imagePath, onPick }) {
    const imageSrc = imagePath || "/og_image_2.jpg";
    return (
        <button
            onClick={onPick}
            className="group h-full flex flex-col text-left rounded-2xl border bg-white p-4 shadow-sm hover:shadow transition"
        >
            {/* Блок с фиксированным соотношением сторон — картинки одинаковой высоты */}
            <div className="relative aspect-[4/3] w-full overflow-hidden rounded-lg border">
                <img
                    src={imageSrc}
                    alt={title}
                    className="absolute inset-0 h-full w-full object-cover object-top"
                    loading="lazy"
                />
            </div>

            {/* Строка сразу под изображением: верх текста и кнопки = низ картинки */}
            <div className="mt-3 flex items-start justify-between gap-3">
                <div className="font-semibold text-slate-900 leading-tight">
                    {title}
                </div>
                <span
                    className="shrink-0 self-start text-blue-700 text-sm opacity-0 group-hover:opacity-100 transition">
          Выбрать
        </span>
            </div>
        </button>
    );
}
